import { AuthDispatchContext } from 'contexts/AuthContext'
import useCustomContext from './useCustomContext'

function useAuthDispatch() {
  return useCustomContext(AuthDispatchContext, useAuthDispatch.name)
}

export default useAuthDispatch
